import "./DatasetItem.less"
import { DatasetInfo } from "../../store/DatasetStore";
import { ColorImg } from "../ColorImg/ColorImg";
import Images from "../../utils/Images";
import { Popover } from "antd";
import { useRef } from "react";

type DatasetItemMenuProps = {
    items: any[][];
};

export const DatasetItemMenu = (props: DatasetItemMenuProps): React.ReactElement => {
    return <div className="dataset-item-menu">
        {props.items.map((item, i) =>
            (item[3] || (() => true))() && <div key={i} className="dataset-item-menu-item" onClick={item[2]}>
                <ColorImg src={item[0]}></ColorImg>
                <span>{item[1]}</span>
            </div>)}
    </div>;
};

type DatasetItemProps = {
    info: DatasetInfo;
    index: number;
    onImgManageClick: (a: DatasetInfo, index: number) => void;
    onEditClick: (a: DatasetInfo, index: number) => void;
    onDeleteClick: (a: DatasetInfo, index: number) => void;
    onCopyClick: (a: DatasetInfo, index: number) => void;
    onDownloadClick: (a: DatasetInfo, index: number) => void;
};

export const DatasetItem = (props: DatasetItemProps): React.ReactElement => {
    const bottomRef = useRef<HTMLDivElement>(null);

    const dummyImg = (): React.ReactElement => {
        return <div className="dataset-item-dummy-img" style={{"--img": `url(${Images.dummy})`} as React.CSSProperties}></div>;
    };

    const singleImg = (): React.ReactElement => {
        return <div className="dataset-item-single-img dataset-item-img" style={{"--img": `url(${props.info.imgs[0].url})`} as React.CSSProperties}></div>;
    };

    const multipleImgs = (): React.ReactElement => {
        return <div className="dataset-item-imgs">
            {Array.from({length: 4}, (v, k) => props.info.imgs[k]).map((item, i) =>
                <div key={i} className="dataset-item-img" style={{"--img": `url(${item.url})`} as React.CSSProperties}></div>)}
        </div>;
    };

    const createImg = (): React.ReactElement => {
        const len = props.info.imgs.length;
        if(len <= 0){
            return dummyImg();
        }

        if(len < 4){
            return singleImg();
        }
        
        return multipleImgs();
    };

    const menuItem: any[][] = [
        [Images.imgCount, "图片管理", () => props.onImgManageClick(props.info, props.index)],
        [Images.edit, "编辑", () => props.onEditClick(props.info, props.index)],
        [Images.download, "下载", () => props.onDownloadClick(props.info, props.index), () => props.info.imgs.length > 0],
        [Images.deleteIcon, "删除", () => props.onDeleteClick(props.info, props.index)],
        // [Images.copy, "复制", () => props.onCopyClick(props.info, props.index)]
    ];

    return <div className="dataset-item">
        <div className="dataset-item-img-wrap">
            {createImg()}
            <div className="dataset-item-to-img-manage-wrap">
                <span onClick={menuItem[0][2]}>用此数据集训练模型</span>
            </div>
        </div>
        <div className="dataset-item-bottom">
            <div className="dataset-item-title">{props.info.title}</div>
            <div className="dataset-item-description">{props.info.description}</div>
            <div className="dataset-item-bottom-icons" ref={bottomRef}>
                {/* <img src={Images.videoCount}></img>
                <span>{props.info.videoCount}</span> */}
                <img src={Images.imgCount}></img>
                <span>{props.info.totalImgCount}</span>
                <Popover getPopupContainer={t => bottomRef.current as HTMLDivElement} placement="top" title={null} arrow={false} content={() => <DatasetItemMenu items={menuItem}></DatasetItemMenu>}>
                    <div className="data-item-bottom-icons-option">
                        <img src={Images.dots}></img>
                        <span>选项</span>
                    </div>
                </Popover>
            </div>
        </div>
    </div>;
};